<template>
  <v-row style="height: 300px">
    <v-col class="pa-3 mt-0">
      <raffle-table :items="winners" :footerProps="footerProps" :headers="prizesTableHeader">
        <template slot="no-data">
          <span>{{ emptyTableMessage }}</span>
        </template>
        <template v-slot:item="{ item, index, props }">
          <tr :key="item + index" class="cinza-l90">
            <td class="table-text--gray">{{ item.user.name }}</td>
            <td class="table-text--gray">{{ item.lucky_number.number }}</td>
            <td class="table-text--gray">{{ item.lucky_number.created_at | date({ fmtIn: 'yyyy-mm-dd', fmtOut: 'dd/mm/yyyy' }) }}</td>
            <td class="table-text--gray">
              <span v-if="item.lucky_number.manually_generated">Sem venda - Gerado manualmente</span>
              <span v-else>{{ item.lucky_number.coupon_created_at | date({ fmtIn: 'yyyy-mm-dd', fmtOut: 'dd/mm/yyyy' }) }}</span>
            </td>
            <td class="table-text--gray">
              <v-tooltip v-model="showTooltipUnit[item.lucky_number.number]" max-width="250" top content-class="truncated-tooltip">
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ item.lucky_number.unit.name | truncate(60) }}
                  </span>
                </template>
                <span>{{ item.lucky_number.unit.name }}</span>
              </v-tooltip>
            </td>
            <td v-if="!item.prize_given" class="blue-action-text" v-bind="props" @click="$emit('editWinner', index, props)">Editar</td>
            <td v-if="item.prize_given"></td>
            <td>
              <div style="width: 150px; height: 100%">
                <mf-toggle
                  v-model="item.prize_given"
                  class="ml-1"
                  hide-details
                  :label="getToggleLabel(item.prize_given)"
                  @change="$emit('prizeStatusChange')"
                />
              </div>
            </td>
          </tr>
        </template>
      </raffle-table>
    </v-col>
  </v-row>
</template>

<script>
import RaffleTable from './RaffleTable.vue'

export default {
  name: 'WinnersTable',
  components: {
    RaffleTable,
  },
  props: {
    winners: {
      type: Array,
      required: false,
    },
    updatePrizeStatus: {
      type: Function,
      required: false,
    },
    emptyTableMessage: {
      type: String,
      required: false,
    },
  },
  data: () => ({
    footerProps: { itemsPerPageOptions: [5] },
    showTooltipUnit: {},
    prizesTableHeader: [
      {
        text: 'Nome',
        value: 'name',
        width: '25%',
        sortable: false,
      },
      {
        text: 'Número da sorte',
        value: 'lucky_number',
        width: '13%',
        sortable: false,
      },
      {
        text: 'Data de aquisição do número',
        value: 'created_at',
        width: '15%',
        sortable: false,
      },
      {
        text: 'Data da venda de aquisição do número',
        value: 'coupon_created_at',
        width: '15%',
        sortable: false,
      },
      {
        text: 'Loja',
        value: 'unit_name',
        width: '15%',
        sortable: false,
      },
      {
        text: '',
        value: '',
        sortable: false,
        width: '13%',
      },
      {
        text: 'Prêmio entregue?',
        value: '',
        sortable: false,
        width: '20%',
      },
    ],
  }),
  methods: {
    getToggleLabel(isActive) {
      return isActive ? 'Entregue' : 'Não entregue'
    },
  },
}
</script>

<style lang="scss" scoped>
.blue-action-text {
  color: $marca-0-l40;
  text-decoration: underline;
  text-align: center;
  &:hover {
    cursor: pointer;
  }
}
.table-text--gray {
  color: '#545454';
  font-size: 12px;
}
</style>
